export function getSignificantNumberString(n, precision) {
    if ((n == null) || isNaN(n) || (n < 0)) {
        return "";
    }
    if ((precision == null) || isNaN(precision) || (precision <= 0) || !Number.isInteger(precision)) {
        return "";
    }
    if (n == 0) {
        return n.toFixed(precision);
    }
    const tp = n.toPrecision(precision);
    if (Number(tp) < Math.pow(10, precision)) {
        return tp;
    }
    const s = Math.round(n) + "";
    const f = Number(s.slice(0, precision) + "." + s.slice(precision));
    return Math.round(f) * Math.pow(10, s.length - precision) + "";
}
